import { Pipe, PipeTransform } from '@angular/core';

import { clienteTiposFiscais } from '../cliente-tipo-fiscal';

@Pipe({
    name: 'clienteTipoFiscalDescricao'
})
export class ClienteTipoFiscalDescricaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = clienteTiposFiscais.findIndex(tipoFiscal => tipoFiscal.id === value);
        if (index > -1) {
            return clienteTiposFiscais[index].descricao;
        }
        return '';
    }
}
